import { FC, Suspense, useContext, useState } from 'react'
import { useIntl } from 'react-intl'
import { Outlet } from 'react-router'

import { UserOutlined } from '@ant-design/icons'
import { Avatar, Button, Flex, Layout, Modal, Spin, theme } from 'antd'
import { useResponsive } from 'antd-style'

import { Context as AuthContext } from '../../providers/Auth'
import placeholder from '../icon/assets/rider.png'
import { Logo } from '../logo/Logo'
import { Burger } from '../navigation/Burger'
import { Footer } from '../navigation/Footer'
import { Header } from '../navigation/Header'
import { Search } from '../search/Search'
import Auth from '../user/Auth'

import { ScrollRestoration, ScrollToTop } from './ScrollRestoration'

const { useToken } = theme

const DefaultLayout: FC = () => {
  const { xs } = useResponsive()
  const { user } = useContext(AuthContext)
  const { formatMessage } = useIntl()
  const [open, setOpen] = useState(false)
  const { token } = useToken()

  return (
    <Layout style={{ minHeight: '100dvh', width: '100%' }}>
      <ScrollRestoration />
      <Layout.Header
        style={{ position: 'sticky', top: 0, zIndex: 1001, width: '100%', display: 'flex', alignItems: 'center' }}
      >
        <Flex gap={12} align={'center'} justify={'space-between'} style={{ width: '100%' }}>
          <Logo size={token.Layout?.headerHeight} />
          {!xs ? <Header /> : null}
          <Flex gap={12}>
            <Search />
            {xs ? <Burger /> : null}
          </Flex>
          {user?.username ? (
            <Avatar src={placeholder} />
          ) : (
            <Button icon={<UserOutlined />} shape={'circle'} onClick={() => setOpen(true)} />
          )}
          <Modal
            title={formatMessage({ id: 'auth.form.title' })}
            open={open}
            onCancel={() => setOpen(false)}
            okButtonProps={{ hidden: true }}
            cancelButtonProps={{ hidden: true }}
          >
            <Auth onSuccess={() => setOpen(false)} />
          </Modal>
        </Flex>
      </Layout.Header>
      <Layout.Content
        className={'blur'}
        style={{ maxWidth: 1200, width: '100%', margin: '0 auto', padding: xs ? 24 : 40 }}
      >
        <Suspense fallback={<Spin fullscreen size={'small'} />}>
          <Outlet />
        </Suspense>
      </Layout.Content>

      <Layout.Footer
        className={'blur'}
        style={{ position: 'sticky', bottom: 0, zIndex: 1002, width: '100%', display: 'flex', alignItems: 'center' }}
      >
        <Footer />
      </Layout.Footer>
      <ScrollToTop />
    </Layout>
  )
}

export { DefaultLayout }
